"use strict";
import React, { useState } from "react";
import classNames from "classnames";
import { Stack } from "../Stack/Stack";
import { Text } from "../Text";
import { ChevronLeft, ChevronRight } from "../../icons";
import * as styles from "./DatePicker-css";
import { days, getDates, getIsoDate, months } from "./DatePickerHelperFunctions";
import IconButton from "../IconButton/IconButton";
import Link from "../Link/Link";
function DatePicker(props) {
  const today = new Date();
  const { singleSelect, startDate, selectStartDate, endDate, selectEndDate } = props;
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [activePicker, setActivePicker] = useState("d");
  const month = getDates(currentYear, currentMonth);
  const isSelectedDate = (day) => {
    if (startDate && getIsoDate(day) === getIsoDate(startDate) || endDate && getIsoDate(day) === getIsoDate(endDate)) {
      return true;
    }
    return false;
  };
  const isInSelectedRange = (day) => {
    const isoDay = new Date(day.year, day.month, day.date).toISOString().split("T")[0];
    if (startDate && endDate) {
      if (getIsoDate(startDate) <= isoDay && isoDay <= getIsoDate(endDate)) {
        return true;
      }
    }
    return false;
  };
  const navigate = (direction) => {
    switch (activePicker) {
      case "d": {
        const updatedMonthIndex = currentMonth + direction;
        setCurrentMonth((updatedMonthIndex >= 0 ? updatedMonthIndex : 12 + updatedMonthIndex) % 12);
        if (updatedMonthIndex < 0 || updatedMonthIndex > 11) {
          setCurrentYear(currentYear + direction);
        }
        return;
      }
      case "m": {
        setCurrentYear(currentYear + direction);
        return;
      }
      case "y": {
        setCurrentYear(currentYear + direction * 12);
        return;
      }
    }
  };
  const updateSelection = (dayClicked) => {
    if (props.allowPastSelection || dayClicked.present >= 0) {
      if (startDate && getIsoDate(dayClicked) == getIsoDate(startDate)) {
        selectStartDate(void 0);
        selectEndDate == null ? void 0 : selectEndDate(void 0);
      } else if (endDate && getIsoDate(dayClicked) == getIsoDate(endDate)) {
        selectEndDate == null ? void 0 : selectEndDate(void 0);
      } else if (singleSelect) {
        selectStartDate(dayClicked);
      } else {
        if (!startDate || startDate && getIsoDate(dayClicked) < getIsoDate(startDate)) {
          selectStartDate(dayClicked);
        } else {
          selectEndDate == null ? void 0 : selectEndDate(dayClicked);
        }
      }
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: styles.datePickerWrapper }, /* @__PURE__ */ React.createElement(Stack, { direction: "horizontal", align: "center", padding: "xs", className: styles.navigation }, /* @__PURE__ */ React.createElement(IconButton, { icon: /* @__PURE__ */ React.createElement(ChevronLeft, null), onClick: () => navigate(-1) }), /* @__PURE__ */ React.createElement(
    Link,
    {
      className: styles.navTitle,
      onClick: () => {
        setActivePicker(activePicker == "d" ? "m" : "y");
      }
    },
    /* @__PURE__ */ React.createElement(Text, { size: "s", strong: true }, activePicker == "y" && `${currentYear - currentYear % 12} - ${currentYear - currentYear % 12 + 11}`, activePicker == "m" && `${currentYear}`, activePicker == "d" && `${month.name} ${currentYear}`)
  ), /* @__PURE__ */ React.createElement(IconButton, { icon: /* @__PURE__ */ React.createElement(ChevronRight, null), onClick: () => navigate(1) })), (() => {
    switch (activePicker) {
      case "d":
        return /* @__PURE__ */ React.createElement(Stack, null, /* @__PURE__ */ React.createElement(Stack, { direction: "horizontal", className: styles.dayTitles }, days.map((day, key) => /* @__PURE__ */ React.createElement(Text, { key, className: styles.day, size: "xs", strong: true }, day.slice(0, 3)))), /* @__PURE__ */ React.createElement(Stack, { className: styles.datesGrid }, [...Array(month.dates[0].day)].map((emptyDay, key) => /* @__PURE__ */ React.createElement(Stack, { key }, /* @__PURE__ */ React.createElement(Text, { className: styles.date }, " "))), month.dates.map((day) => {
          const showRange = startDate && endDate;
          return /* @__PURE__ */ React.createElement(
            Link,
            {
              key: day.date,
              className: classNames(
                styles.dateWrapper,
                isInSelectedRange(day) && styles.selectedRange,
                showRange && getIsoDate(startDate) == getIsoDate(day) && styles.startOfSelection,
                showRange && getIsoDate(endDate) == getIsoDate(day) && styles.endOfSelection
              ),
              onClick: () => updateSelection(day)
            },
            /* @__PURE__ */ React.createElement(
              Text,
              {
                strong: true,
                size: "s",
                className: classNames(
                  styles.date,
                  day.present < 0 ? styles.disabledDate : day.present == 0 && styles.currentDate,
                  isSelectedDate(day) && styles.selected
                )
              },
              day.date
            )
          );
        })));
      case "m":
        return /* @__PURE__ */ React.createElement(Stack, { className: styles.monthSelector }, months.map((month2, index) => /* @__PURE__ */ React.createElement(
          Link,
          {
            key: index,
            onClick: () => {
              setCurrentMonth(index);
              setActivePicker("d");
            }
          },
          /* @__PURE__ */ React.createElement(Text, { strong: true, size: "s" }, month2.slice(0, 3))
        )));
      case "y":
        return /* @__PURE__ */ React.createElement(Stack, { className: styles.yearSelector }, [...Array(12).keys()].map((index) => {
          const year = index + currentYear - currentYear % 12;
          return /* @__PURE__ */ React.createElement(
            Link,
            {
              key: index,
              onClick: () => {
                setCurrentYear(year);
                setActivePicker("m");
              }
            },
            /* @__PURE__ */ React.createElement(Text, { strong: true, size: "s" }, year)
          );
        }));
      default:
        return null;
    }
  })());
}
export { DatePicker };
